import CheckoutRequests from '@/shared/infrastructure/checkout/Request'
import BillingRequests from '@/shared/infrastructure/billing/Request'

const actions = {
  setShippingAddress({ commit }, address) {
    commit('setShippingAddress', address)
  },
  fetchBuyerCards() {
    return BillingRequests.fetchBuyerCards()
  },
  fetchBuyerACH() {
    return BillingRequests.fetchBuyerACH()
  },
  addBuyerCard(actions, payload) {
    return BillingRequests.addBuyerCard(payload)
  },
  addBuyerAccount(actions, tokenId) {
    return BillingRequests.addBuyerAccount(tokenId)
  },
  deleteBuyerCard(actions, id) {
    return BillingRequests.deleteBuyerCard(id)
  },
  deleteBuyerAchAccount(actions, id) {
    return BillingRequests.deleteBuyerAchAccount(id)
  },
  verifyBuyerAchAccount(actions, formData) {
    return BillingRequests.verifyBuyerAchAccount(formData)
  },
  async createCheckoutSummary({ commit }, formData) {
    const result = await BillingRequests.createCheckoutSummary(formData)
    if (!result.error) {
      commit('setCheckoutSummary', result)
    }
    return result
  },
  placeOrder(actions, link) {
    return CheckoutRequests.placeOrder(link)
  },
  checkReferralCode(actions, payload) {
    return CheckoutRequests.checkReferralCode(payload)
  },
  referralCodeApplied({ commit }, payload) {
    commit('referralCodeApplied', payload)
  },
  removeReferralCode({ commit }) {
    commit('removeReferralCode')
  }
}

export default actions
